import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCloudRain, FaThermometerHalf } from "react-icons/fa";

import FarmMapPluviometry from "./FarmMapPluviometry";
import FarmClimateLog from "./FarmClimateLog";

import "./FarmMapTrackHeadings.css";
import "./FarmMapPluviometry.css";
import "./FarmRainHistory.css";

function FarmRainHistory() {
  const { farm_id: farmId } = useParams();
  const { t } = useTranslation();
  const [view, setView] = useState("rain");

  useEffect(() => {
    document.title =
      view === "weather"
        ? "Agriconnected - Histórico de clima"
        : "Agriconnected - Histórico de chuva";
  }, [view]);

  return (
    <div className="farm-map-page">
      <div className="farm-map-page__header farm-rain-history__header">
        <h1>
          {view === "weather"
            ? t("Histórico de clima e temperatura")
            : t("Histórico de chuva")}
        </h1>
        <div className="farm-rain-history__tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={view === "rain"}
            className={
              view === "rain"
                ? "farm-rain-history__tab farm-rain-history__tab--active"
                : "farm-rain-history__tab"
            }
            title={t("Chuva")}
            onClick={() => setView("rain")}
          >
            <FaCloudRain />
            <span>{t("Chuva")}</span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={view === "weather"}
            className={
              view === "weather"
                ? "farm-rain-history__tab farm-rain-history__tab--active"
                : "farm-rain-history__tab"
            }
            title={t("Clima")}
            onClick={() => setView("weather")}
          >
            <FaThermometerHalf />
            <span>{t("Clima")}</span>
          </button>
        </div>
      </div>
      {view === "weather" ? (
        <FarmClimateLog farmId={farmId} />
      ) : (
        <FarmMapPluviometry farmId={farmId} />
      )}
    </div>
  );
}

export default FarmRainHistory;
